import 'babel-polyfill';
import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { createStore, applyMiddleware } from 'redux';
import reducers from './reducers';
import reduxThunk from 'redux-thunk';
import { Router, Route } from 'react-router-dom';

//import Home from './components/home';
import EndofDay from './containers/endofday';
import DetailedOrder from './containers/detailed_order';
import Timesheets from './containers/timesheets';
import Pos from './containers/pos';
import OpenOrders from './containers/open_orders';
import ClosedOrders from './containers/closed_orders';
import Dashboard from './containers/dashboard';

import RequireAuth from './containers/auth/require_auth';
import Signin from './containers/auth/signin';
import Signout from './containers/auth/signout';
import Signup from './containers/auth/signup';
import SigninPOS from './containers/auth/signin_pos';
import ForgotPassword from './containers/auth/forgot_password';
import PasswordReset from './containers/auth/password_reset';
import { AUTH_USER } from './actions';
import throttle from 'lodash/throttle';
import history from './history'
//import './index.css';
//import 'bootstrap/dist/css/bootstrap.css';
import { loadState, saveState } from './localstorage';

// Grab any local storage values to preload the state
const preloadedState = loadState();
const createStoreWithMiddleWare = applyMiddleware(reduxThunk)(createStore);

const store = createStoreWithMiddleWare(reducers, preloadedState);
const token = localStorage.getItem('token');
if (token) {
  store.dispatch({ type: AUTH_USER });
}

// Used only for debugging, remove later
window.store = store;

// See if the socket buffer exists before passing it to saveState
var socketBuffer = [];
try {
  socketBuffer = store.getState().auth.socket.sendBuffer;
} catch(e) {
  // Ignore errors
}

// Save certain data to local storage, but only once every second
// (the throttling is recommended by the redux creator)
store.subscribe(throttle(() => {
  saveState({
    restaurant: store.getState().restaurant,
    current_order: store.getState().current_order,
    orders: store.getState().orders,
    polling: store.getState().polling,
  }, socketBuffer);
}, 1000));

// Set up React router and the root node
ReactDOM.render(
  <Router history={history}>
    <Provider store={store}>
      <div>
        <Route exact path="/" component={Signin} />
        <Route path="/signout" component={Signout} />
        <Route path="/signup" component={Signup} />
        <Route path="/signinpos" component={SigninPOS} />
        <Route path="/forgotpassword" component={ForgotPassword} />
        <Route path="/passwordreset/:token" component={PasswordReset} />
        <Route path="/dashboard" component={RequireAuth(Dashboard)} />
        <Route exact path="/pos/closedorders" component={RequireAuth(ClosedOrders)} />
        <Route exact path="/pos/openorders" component={RequireAuth(OpenOrders)} />
        <Route exact path="/pos" component={RequireAuth(Pos)} />
        <Route path="/reports/endofday" component={RequireAuth(EndofDay)} />
        <Route path="/reports/detailedorder" component={RequireAuth(DetailedOrder)} />
        <Route path="/reports/timesheets" component={RequireAuth(Timesheets)} />
      </div>
    </Provider>
  </Router>,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js